<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Attach Deployment to Workstation</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>
  <div class="modal-body">
    <p>Following workstations " {{ this.data.wsName.toString() }} " will be attached to the selected deployment.</p>
    <form [formGroup]="attachDeploymentForm" spellcheck="false" autocomplete="off">
      <mat-form-field style="width: 100%;">
        <mat-label>Select Deployment</mat-label>
        <mat-select formControlName="deploymentName" placeholder="No Deployment Selected" multiple title="Deployments which are already attached to selected workstation will not be shown">
          <mat-option *ngFor="let depName of deploymentNames"
                      value="{{ depName }}">{{ depName }}</mat-option>
          <mat-option *ngIf="deploymentNames.length == 0" disabled>No Deployment Available</mat-option>
        </mat-select>

        <mat-error *ngIf='attachDeploymentForm.get("deploymentName").touched && attachDeploymentForm.get("deploymentName").errors?.required'>Required</mat-error>
      </mat-form-field>
      <button type="button"
              title="Create new deployment"
              class="default-btn"
              style="margin-right:66%"
              [matMenuTriggerFor]="cloudWizardType">
        <span class="bi bi-plus-lg"></span>
        New Deployment
      </button>
      <mat-menu #cloudWizardType="matMenu">
        <button
          type="button"
          *ngFor="let provider of cloudProviders"
          mat-menu-item
          (click)="addDeployment(provider.providerValue, provider.providerName)"
        >
          {{ provider.providerName }}
        </button>
    </mat-menu>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary" [disabled]="!attachDeploymentForm.valid" (click)="onSubmit()">
      Attach
    </button>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="wsAttach"
    ><p class="pleaseWait">Please wait ...</p></ngx-spinner
  >
</div>
